<template>
  <div class="body">
    <div class="topTip"></div>
    <div class="top">
      <div>顾村公园大数据智慧屏</div>
      <img src="@/assets/img/list.png" @click="openList()"/>
    </div>
    <div class="qntj listshow1" >
      <div class="rytj">
        <div>
          <div>全年累计入园(人次)&nbsp&nbsp</div>
          <div style="color: rgb(248, 240, 35);" class="yellow">{{annual}}</div>
        </div>
        <div>
          <div>单日最大承载(人次)&nbsp&nbsp</div>
          <div style="color: rgb(248, 240, 35);" class="yellow">{{sameDay}}</div>
        </div>
        <div>
          <div>瞬时最大承载(人次)&nbsp&nbsp</div>
          <div style="color: rgb(248, 240, 35);" class="yellow">{{instant}}</div>
        </div>
      </div>
      <div class="ssd">
        <div class="yyssd">游园舒适度</div>
<!--        <div class="yyssd_1">{{comfort}}</div>-->
        <div style="height: calc(100% - .5rem);width: .9rem;margin-left: calc((100% - .9rem)/2)">
          <img style="width: 100%;height: 100%;" :src="comfort=='1' ? require('../assets/img/shushi.gif'): (comfort=='2' ? require('../assets/img/jiaoshushi.gif'):(comfort=='3' ? require('../assets/img/yiban.gif'):require('../assets/img/yongji.gif')))"/>
        </div>
      </div>
    </div>
<!--    <div class="qx_info">-->
<!--      游园天气-->
<!--      <span>-->
<!--        <div><img :src="weatherInfoImg"/>{{weatherInfoQw}}</div>-->
<!--        <div v-if="weatherInfoTem"><img class="tq_img2" src="@/assets/img/wd.png"/>{{weatherInfoTem}}℃</div>-->
<!--        <div v-if="weatherInfoRhu"><img class="tq_img3" src="@/assets/img/sd.png"/>{{weatherInfoRhu}}%</div>-->
<!--      </span>-->
<!--    </div>-->
    <div class="part_1 listshow2">
      <img class="part_img_1" src="@/assets/img/border_1.png"/>
      <img class="part_img_2" src="@/assets/img/border_2.png"/>
      <img class="part_img_3" src="@/assets/img/border_3.png"/>
      <img class="part_img_4" src="@/assets/img/border_4.png"/>
      <div class="part_title ">今日统计</div>
      <div class="part_1_info">
        <div class="part_1_1">
          <div class="ryrc">入园(人次)</div>
          <div class="ryrc_num">{{allPassengerFlowNum.inNum}}</div>
        </div>
        <div class="part_1_1" style="margin-top: .12rem">
          <div class="ryrc">在园(人次)</div>
          <div class="ryrc_num">{{allPassengerFlowNum.existNum}}</div>
        </div>
        <div class="part_1_1" style="margin-top: .12rem">
          <div class="ryrc">出园(人次)</div>
          <div class="ryrc_num">{{allPassengerFlowNum.outNum}}</div>
        </div>
      </div>
      <div class="part_2_info">
        <div class="part_1_1">
          <div class="ryrc">已预约(人次)</div>
          <div class="ryrc_num">{{sameDayStatistics.yuYue}}</div>
        </div>
        <div class="part_1_1" style="margin-top: .12rem">
          <div class="ryrc">已入园(人次)</div>
          <div class="ryrc_num">{{sameDayStatistics.ruYuan}}</div>
        </div>
        <div class="part_1_1" style="margin-top: .12rem">
          <div class="ryrc">未入园(人次)</div>
          <div class="ryrc_num">{{sameDayStatistics.weiRuYuan}}</div>
        </div>
      </div>
    </div>
    <div class="part_2 listshow3">
      <img class="part_img_1" src="@/assets/img/border_1.png"/>
      <img class="part_img_2" src="@/assets/img/border_2.png"/>
      <img class="part_img_3" src="@/assets/img/border_3.png"/>
      <img class="part_img_4" src="@/assets/img/border_4.png"/>
      <div class="part_title">各入口统计</div>
      <div class="data_table">
        <img src="@/assets/img/jx_1.png"/>
        <div>
          <div></div>
          <div>入园人次</div>
          <div>出园人次</div>
        </div>
      </div>
      <div class="data_table_tr">
        <ul>
          <li>
            <div>1号口</div>
            <div style="color: rgb(248, 240, 35)">{{onePassengerFlowNum.inNum}}</div>
            <div style=" color: rgb(238, 55, 245);">{{onePassengerFlowNum.outNum}}</div>
          </li>
        </ul>
        <ul>
          <li>
            <div>2号口</div>
            <div style="color: rgb(248, 240, 35)">{{twoPassengerFlowNum.inNum}}</div>
            <div style=" color: rgb(238, 55, 245);">{{twoPassengerFlowNum.outNum}}</div>
          </li>
        </ul>
        <ul>
          <li style=" margin-bottom:-1px ;">
            <div>3号口</div>
            <div style="color: rgb(248, 240, 35)">{{threePassengerFlowNum.inNum}}</div>
            <div style=" color: rgb(238, 55, 245);">{{threePassengerFlowNum.outNum}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="part_3 listshow4">
      <div class="part3_title">入园监控</div>
      <div class="minVideoViewBox">
        <div class="miniStreamView" v-for="item in nvrList">
          <div>{{item.cameraName}}</div>
            <div class="nvr" @click="showNvr(item.cameraName)"><iframe :src="item.flowUrl"  allow="autoplay"
                         border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes" allowfullscreen ></iframe></div>
          <div class="showNvr" @click="showNvr(item.cameraName)"></div>
      </div>
    </div>
    </div>
    <div class="part_4 listshow5">
      <img class="part_img_1" src="@/assets/img/border_1.png"/>
      <img class="part_img_2" src="@/assets/img/border_2.png"/>
      <img class="part_img_3" src="@/assets/img/border_3.png"/>
      <img class="part_img_4" src="@/assets/img/border_4.png"/>
      <div class="part_title">今日预约统计</div>
      <div class="excel_1">
        <div class="data_table3">
          <img src="@/assets/img/jx_1.png"/>
          <div>
            <div class="table3">各时段预约入园人数</div>
          </div>
        </div>
        <div id="gsdrs" class="gsdrs"> </div>
      </div>
      <div class="excel_2">
        <div class="data_table3">
          <img src="@/assets/img/jx_1.png"/>
          <div>
            <div class="table3">近期预约入园人数</div>
          </div>
        </div>
        <div id="jqyyrs" class="jqyyrs"> </div>
      </div>
      <div class="excel_3">
        <div class="data_table3">
          <img src="@/assets/img/jx_1.png"/>
          <div>
            <div class="table3">公园售票类型分布图</div>
          </div>
        </div>
        <div id="gysplx" class="gysplx"> </div>
      </div>
    </div>
    <div class="part_5 listshow6">
      <img class="part_img_1" src="@/assets/img/border_1.png"/>
      <img class="part_img_2" src="@/assets/img/border_2.png"/>
      <img class="part_img_3" src="@/assets/img/border_3.png"/>
      <img class="part_img_4" src="@/assets/img/border_4.png"/>
      <div class="part_title ">今日游客画像</div>
      <div class="excel_4">
        <div class="data_table3">
          <img src="@/assets/img/jx_1.png"/>
          <div>
            <div class="table3">年龄分布</div>
          </div>
        </div>
        <div id="nlfb" class="nlfb"> </div>
      </div>
      <div class="excel_5">
        <div class="excel_5_left">
          <div class="data_table4">
            <img src="@/assets/img/jx_1.png"/>
            <div>
              <div class="table4">来源地</div>
            </div>
            <div class="excel_5_info" v-if="this.num0 !=0">
              <div style="color: #ffffff">No.1</div>
              <div>{{this.useCardName1}}</div>
              <div>{{this.num0}}</div>
            </div>
            <div class="excel_5_info" v-if="this.num1 !=0">
              <div style="color: #ffffff">No.2</div>
              <div>{{this.useCardName2}}</div>
              <div>{{this.num1}}</div>
            </div>
            <div class="excel_5_info" v-if="this.num2 !=0">
              <div style="color: #ffffff">No.3</div>
              <div>{{this.useCardName3}}</div>
              <div>{{this.num2}}</div>
            </div>
            <div class="excel_5_info" v-if="this.num3 !=0">
              <div style="color: #ffffff">No.4</div>
              <div>{{this.useCardName4}}</div>
              <div>{{this.num3}}</div>
            </div>
            <div class="excel_5_info" v-if="this.num4 !=0">
              <div style="color: #ffffff">No.5</div>
              <div>{{this.useCardName5}}</div>
              <div>{{this.num4}}</div>
            </div>
          </div>
        </div>
        <div class="excel_5_left" style="margin-left: 5%">
          <div class="data_table4">
            <img src="@/assets/img/jx_1.png"/>
            <div>
              <div class="table4">性别比</div>
            </div>
          </div>
          <div id="xbb" class="xbb"> </div>
        </div>
      </div>
    </div>
    <div class="part_6 listshow7">
      <img class="part_img_1" src="@/assets/img/border_1.png"/>
      <img class="part_img_2" src="@/assets/img/border_2.png"/>
      <img class="part_img_3" src="@/assets/img/border_3.png"/>
      <img class="part_img_4" src="@/assets/img/border_4.png"/>
      <div class="part_title">停车场车位统计</div>
      <div class="data_table2">
        <img src="@/assets/img/jx_1.png"/>
        <div>
          <div></div>
          <div>总车位(个)</div>
          <div>已使用(个)</div>
          <div>空闲(个)</div>
        </div>
      </div>
      <div class="data_table_tr2">
        <ul>
          <li>
            <div>1号停车场</div>
            <div style="color: rgb(248, 240, 35)">{{parkingSpace.oneSpaceCount}}</div>
            <div style="color: rgb(248, 240, 35)">{{parkingSpace.oneSpaceCount - parkingSpace.oneFreeSpaceCount}}</div>
            <div style="color: rgb(248, 240, 35)">{{parkingSpace.oneFreeSpaceCount}}</div>
          </li>
        </ul>
        <ul>
          <li>
            <div>2号停车场</div>
            <div style="color: rgb(248, 240, 35)">{{parkingSpace.twoSpaceCount}}</div>
            <div style="color: rgb(248, 240, 35)">{{parkingSpace.twoSpaceCount - parkingSpace.twoFreeSpaceCount}}</div>
            <div style="color: rgb(248, 240, 35)">{{parkingSpace.twoFreeSpaceCount}}</div>
          </li>
        </ul>
        <ul>
          <li style=" margin-bottom:-1px ;">
            <div>3号停车场</div>
            <div style="color: rgb(248, 240, 35)">{{parkingSpace.threeSpaceCount}}</div>
            <div style="color: rgb(248, 240, 35)">{{parkingSpace.threeSpaceCount - parkingSpace.threeFreeSpaceCount}}</div>
            <div style="color: rgb(248, 240, 35)">{{parkingSpace.threeFreeSpaceCount}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="showQRCode" v-show="showList">
      <div class="bars">
        <div>顾村公园大数据智慧屏</div>
        <div class="bar1" @click="closeList()">×</div>
      </div>
      <ul class="parentWrap">
        <li class="menuGroup" @click="showDetails(1)">
						<span class="groupTitle">
							<div>概述</div>
              <!--							<img class="xia" src="@/assets/img/xia.png" />-->
						</span>
        </li>
        <li class="menuGroup" style="background-color: #f5f5f4;"  @click="showDetails(2)">
						<span class="groupTitle">
							<div>今日统计</div>
              <!--<img class="xia" src="@/assets/img/xia.png" />-->
						</span>
        </li>
        <li class="menuGroup" @click="showDetails(3)">
						<span class="groupTitle">
							<div>各入口统计（今日）</div>
              <!--<img class="xia" src="@/assets/img/xia.png" />-->
						</span>
        </li>
        <li class="menuGroup" style="background-color: #f5f5f4;" @click="showDetails(4)">
						<span class="groupTitle">
							<div>入园监控</div>
              <!--<img class="xia" src="@/assets/img/xia.png" />-->
						</span>
        </li>
        <li class="menuGroup" @click="showDetails(5)">
						<span class="groupTitle">
							<div>今日预约统计</div>
              <!--<img class="xia" src="@/assets/img/xia.png"/>-->
						</span>
        </li>
        <li class="menuGroup" style="background-color: #f5f5f4;" @click="showDetails(6)">
						<span class="groupTitle">
							<div>今日游客画像</div>
              <!--<img class="xia" src="@/assets/img/xia.png" />-->
						</span>
        </li>
        <li class="menuGroup" @click="showDetails(7)">
						<span class="groupTitle" >
							<div>停车场车位统计</div>
              <!--<img class="xia" src="@/assets/img/xia.png"/>-->
						</span>
        </li>
      </ul>
    </div>
    <div class="playNvr" v-if="isShowNvr">
      <div class="nvrTitle"><div class="close" @click="closNvrUrl">X</div></div>
      <div class="nvrUrl" v-for="item in nvrList" v-if="item.cameraName==showNvrUrl">
        <iframe :src="item.flowUrl" allowfullscreen allow="autoplay"
                border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"></iframe>
      </div>
      <!--      <div class="nvrUrl">-->
      <!--        <iframe :src="isShowNvr" allowfullscreen allow="autoplay"-->
      <!--                border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"></iframe>-->
      <!--      </div>-->
    </div>


  </div>

</template>

<script>
  let echarts = require('echarts/lib/echarts');
  import {getNvrList,getPassengerFlowList,getSameDayStatistics,passengerFlow,getParkingSpace,getSameDayStatisticsTime} from '../api/statistics/statistics.js';
  import {data} from '../common/js/provincesutil';
  export default {
    name: "app_dp",
    data() {
      return {
        showList: false,
        showIndex:null,
        nvrList:'',
        annual:'',
        sameDay:'',
        instant:'',
        sameDayStatistics:'',
        sameDayStatisticsTime:'',
        option : {},
        Time:[],
        useCardName1:'',
        useCardName2:'',
        useCardName3:'',
        useCardName4:'',
        useCardName5:'',
        yMax:0,
        passengerFlowNum:{},
        onePassengerFlowNum:{},
        twoPassengerFlowNum:{},
        threePassengerFlowNum:{},
        allPassengerFlowNum:{},
        comfort:'1',
        parkingSpace:{},  //停车场
        showNvrUrl:"",
        isShowNvr:false,
        num0:0,
        num1:0,
        num2:0,
        num3:0,
        num4:0,
        weatherInfoTem:"",
        weatherInfoRhu:"",
        weatherInfoImg:"", //气温图标
        weatherInfoQw:"", //气温情况
      }
    },
    created() {
      this.getNvrInfo();
      this.init_data();
      setInterval(this.init_data, 30000);
    },
    methods: {
      getNvrInfo(){

        // 查询nvr信息
        getNvrList().then((res) => {
          if (res.code==200){
            this.nvrList = res.data;
            console.log(this.nvrList);
            for (var i = 0; i < this.nvrList.length; i++) {
              this.nvrList[i].flowUrl = this.nvrList[i].flowUrl + "?rel=0&amp;autoplay=1";
            }
          }
        })
      },
      showDetails(num){
        this.showList = false;
        var el=document.getElementsByClassName(`listshow${num}`)[0];
        console.log(el.offsetTop);
        if(this.showIndex==num){
          this.showIndex=null;
        }else{
          this.showIndex=num;
        }
        this.$nextTick(function () {
          window.scrollTo({"behavior":"smooth","top":el.offsetTop-60});
        })
      },
      init_data() {
          //查询客流
          passengerFlow().then((res) => {
            if (res.code==200){
              console.log(res);
              this.passengerFlowNum = res.data;
              this.onePassengerFlowNum = res.data.OEN_PASSENGERFLOW;
              this.twoPassengerFlowNum = res.data.TWO_PASSENGERFLOW;
              this.threePassengerFlowNum = res.data.THREE_PASSENGERFLOW;
              this.allPassengerFlowNum = res.data.TOTAL_PASSENGERFLOW;
              this.weatherInfoTem = res.data.weatherInfoTem;
              this.weatherInfoRhu = res.data.weatherInfoRhu;
              this.weatherInfoQw = res.data.weatherInfoQw;
              this.weatherInfoImg = res.data.weatherInfoImg;
              this.comfort = res.data.COMFORT;
            }else if (res.code==403){
              this.$router.push({
                path: '/app_login'
              })
              return;
            }
          }),
            //查询停车场
            getParkingSpace().then((res) => {
              if (res.code==200){
                console.log(res);
                this.parkingSpace = res.data;
              }
            }),
          getPassengerFlowList().then((res)=>{
            console.log(res.data[0]);
            if (res.code==200){
              if (res.data[0].annual == null){
                this.annual='000'
              }
              if (res.data[0].sameDay == null){
                this.sameDay='000'
              }
              if (res.data[0].instant == null){
                this.instant='000'
              }
              this.annual = res.data[0].annual;
              this.sameDay = res.data[0].sameDay;
              this.instant = res.data[0].instant;
            }else {
              this.annual = '000';
              this.sameDay = '000';
              this.instant = '000';
            }
          }),
            getSameDayStatisticsTime().then((res)=>{
              if (res.code==200){
                this.sameDayStatisticsTime = res.data;
                this.time = [];
                this.time.push(this.sameDayStatisticsTime.time1);
                this.time.push(this.sameDayStatisticsTime.time2);
                this.time.push(this.sameDayStatisticsTime.time3);
                this.time.push(this.sameDayStatisticsTime.time4);
                this.time.push(this.sameDayStatisticsTime.time5);
                this.time.push(this.sameDayStatisticsTime.time6);
                this.time.push(this.sameDayStatisticsTime.time7);
                this.timeNumber = [];
                this.timeNumber.push(this.sameDayStatisticsTime.timeNumber1);
                this.timeNumber.push(this.sameDayStatisticsTime.timeNumber2);
                this.timeNumber.push(this.sameDayStatisticsTime.timeNumber3);
                this.timeNumber.push(this.sameDayStatisticsTime.timeNumber4);
                this.timeNumber.push(this.sameDayStatisticsTime.timeNumber5);
                this.timeNumber.push(this.sameDayStatisticsTime.timeNumber6);
                this.timeNumber.push(this.sameDayStatisticsTime.timeNumber7);
              }
              this.$nextTick(function () {
                this.drawLine();
              });
            }),
          getSameDayStatistics().then((res)=>{
            if (res.code==200){
              this.sameDayStatistics = res.data;
              console.log(this.sameDayStatistics);
              this.Time = [];
              this.Time.push(this.sameDayStatistics.fiveTime);
              this.Time.push(this.sameDayStatistics.fourTime);
              this.Time.push(this.sameDayStatistics.twoTime+this.sameDayStatistics.threeTime);
              this.Time.push(this.sameDayStatistics.oneTime);
              this.yMax = this.sameDayStatistics.fiveTime+this.sameDayStatistics.fourTime+this.sameDayStatistics.threeTime+this.sameDayStatistics.twoTime+this.sameDayStatistics.oneTime;
              let city = data.province;
              if (this.sameDayStatistics.sourceList.length == 1) {
                var useCard1 = this.sameDayStatistics.sourceList[0].useCard+"0000";
                this.useCardName1 =city[useCard1];
                this.num0 = this.sameDayStatistics.sourceList[0].num;
              }else if (this.sameDayStatistics.sourceList.length == 2){
                var useCard1 = this.sameDayStatistics.sourceList[0].useCard+"0000";
                var useCard2 = this.sameDayStatistics.sourceList[1].useCard+"0000";
                this.useCardName1 =city[useCard1];
                this.useCardName2 =city[useCard2];
                this.num0 = this.sameDayStatistics.sourceList[0].num;
                this.num1 = this.sameDayStatistics.sourceList[1].num;
              }else if (this.sameDayStatistics.sourceList.length == 3){
                var useCard1 = this.sameDayStatistics.sourceList[0].useCard+"0000";
                var useCard2 = this.sameDayStatistics.sourceList[1].useCard+"0000";
                var useCard3 = this.sameDayStatistics.sourceList[2].useCard+"0000";
                this.useCardName1 =city[useCard1];
                this.useCardName2 =city[useCard2];
                this.useCardName3 =city[useCard3];
                this.num0 = this.sameDayStatistics.sourceList[0].num;
                this.num1 = this.sameDayStatistics.sourceList[1].num;
                this.num2 = this.sameDayStatistics.sourceList[2].num;
              } else if (this.sameDayStatistics.sourceList.length == 4){
                var useCard1 = this.sameDayStatistics.sourceList[0].useCard+"0000";
                var useCard2 = this.sameDayStatistics.sourceList[1].useCard+"0000";
                var useCard3 = this.sameDayStatistics.sourceList[2].useCard+"0000";
                var useCard4 = this.sameDayStatistics.sourceList[3].useCard+"0000";
                this.useCardName1 =city[useCard1];
                this.useCardName2 =city[useCard2];
                this.useCardName3 =city[useCard3];
                this.useCardName4 =city[useCard4];
                this.num0 = this.sameDayStatistics.sourceList[0].num;
                this.num1 = this.sameDayStatistics.sourceList[1].num;
                this.num2 = this.sameDayStatistics.sourceList[2].num;
                this.num3 = this.sameDayStatistics.sourceList[3].num;
              }else if (this.sameDayStatistics.sourceList.length == 5){
                var useCard1 = this.sameDayStatistics.sourceList[0].useCard+"0000";
                var useCard2 = this.sameDayStatistics.sourceList[1].useCard+"0000";
                var useCard3 = this.sameDayStatistics.sourceList[2].useCard+"0000";
                var useCard4 = this.sameDayStatistics.sourceList[3].useCard+"0000";
                var useCard5 = this.sameDayStatistics.sourceList[4].useCard+"0000";
                this.useCardName1 =city[useCard1];
                this.useCardName2 =city[useCard2];
                this.useCardName3 =city[useCard3];
                this.useCardName4 =city[useCard4];
                this.useCardName5 =city[useCard5];
                this.num0 = this.sameDayStatistics.sourceList[0].num;
                this.num1 = this.sameDayStatistics.sourceList[1].num;
                this.num2 = this.sameDayStatistics.sourceList[2].num;
                this.num3 = this.sameDayStatistics.sourceList[3].num;
                this.num4 = this.sameDayStatistics.sourceList[4].num;
              }
            }
            console.log(this.Time);
            this.$nextTick(function () {
              this.drawLine();
            });
          })
      },
      showNvr(nvrUrl){
        console.log(nvrUrl)
        this.isShowNvr = true;
        this.showNvrUrl = nvrUrl;
      },
      closNvrUrl(){
        this.isShowNvr = false;
      },
      drawLine(){
        let myChart = echarts.init(document.getElementById('gsdrs'));
        window.onresize = myChart.resize;
        myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: 0
        });
        // 绘制图表

        var dataShadows = [];
        for (let i = 0; i < this.Time.length; i++) {
          dataShadows.push(this.yMax);
          console.log(dataShadow);
        }
        var maxdata=dataShadows[0];
        for(var n=1;n<dataShadows.length;n++){
          if(dataShadows[n]>maxdata){
            maxdata=dataShadows[n];
          }
        }
        var dataShadow = [];
        for (let i = 0; i < this.Time.length; i++) {
          dataShadow.push(maxdata);
          console.log(dataShadow);
        }

        myChart.setOption({
          grid: {
            left: '3%',
            right: '5%',
            bottom: '-5%',
            top:'2%',
            containLabel: true
          },
          yAxis: [{
            type: 'category',
            data: ['15-18时', '12-15时', '9-12时', '6-9时'],
            axisLabel: {
              color: '#ffffff'
            }
          },{
            type: 'category',
            data: ['15-18时', '12-15时', '9-12时', '6-9时'],
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
          },],
          xAxis: {
            type: 'value',
            splitLine: { // 网格线
              show: true,
              lineStyle: {
                color: '#3f51b5'
              }
            },
            axisTick: {
              show: false, // 是否显示坐标轴轴线
            },
            axisLabel: { //坐标轴刻度标签的相关设置。
              show: false,
            },
            axisLine:{
              show:false
            }
          },
          series: [{
            type: 'bar',
            barGap: '100%',
            zlevel: 1,
            yAxisIndex:1,
            data: dataShadow,
            barMaxWidth: 15,
            itemStyle: {
              normal: {
                color: '#0f2051',
                borderWidth: 0,
                shadowBlur: {
                  shadowColor: 'rgba(0, 0, 0, 0.5)',
                  shadowBlur: 10,
                  shadowOffsetY: 0,
                },
              }
            },
          },{
            data: this.Time,
            type: 'bar',
            barGap: '100%',
            barMaxWidth: 15,
            zlevel: 2,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                  type: 'linear',
                  offset: 0,
                  color: '#114389'
                }, {
                  offset: 1,
                  color: '#148dfe'
                }]),
              }
            },
            label:{
              show:true,
              position:'right',
              color: '#ffffff'
            }
          }]
        });
        let myChart1 = echarts.init(document.getElementById('gysplx'));
        window.onresize = myChart1.resize;
        myChart1.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart1.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart1.setOption({
          tooltip: {
            trigger: 'item'
          },
          grid: {
            left: '3%',
            right: '0%',
            bottom: '-5%',
            top:'0%',
            containLabel: true
          },
          series: [
            {
              type: 'pie',
              radius: ['40%', '70%'],
              data: [
                {value: this.sameDayStatistics.ticketType1, name: '学生票数'},
                {value: this.sameDayStatistics.ticketType3, name: '免票数'},
                {value: this.sameDayStatistics.ticketType2, name: '老年票数'},
                {value: this.sameDayStatistics.ticketType0, name: '成人票数'},
              ],
              axisLabel: {
                color: '#ffffff'
              },
              labelLine: {
                smooth: 0.2,
                length: 10,
                length2: 10
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              itemStyle: {
                //通常情况下：
                normal: {
                  //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                  color: function(params) {
                    var colorList = [
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#7f11f7'
                      }, {
                        offset: 1,
                        color: '#ed38ef'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#fa755a'
                      }, {
                        offset: 1,
                        color: '#fa542b'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#2948d5'
                      }, {
                        offset: 1,
                        color: '#1d5bd8'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#fb9d0a'
                      }, {
                        offset: 1,
                        color: '#f9e21d'
                      }]),
                    ]; //每根柱子的颜色
                    return colorList[params.dataIndex];
                  }
                },
              },
              label:{
                show:true,
                color: '#ffffff'
              }
            }
          ]
        });
        let myChart2 = echarts.init(document.getElementById('jqyyrs'));
        window.onresize = myChart2.resize;
        myChart2.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart2.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart2.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            top:'10%',
            bottom: '-4%',
            right: '0%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: [this.sameDayStatisticsTime.time1,this.sameDayStatisticsTime.time2, this.sameDayStatisticsTime.time3, this.sameDayStatisticsTime.time4, this.sameDayStatisticsTime.time5, this.sameDayStatisticsTime.time6, this.sameDayStatisticsTime.time7],
            axisLabel: {
              interval:0,
              rotate:30,
              color: '#ffffff',
              fontSize : 8
            },
            axisTick:{       //x轴刻度线
              show:false
            },
            splitLine: { // 网格线
              show: true,
              lineStyle: {
                color: '#1f3a5f'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#1f3a5f'
              }
            },
          },
          yAxis: {
            type: 'value',
            splitLine: { // 网格线
              show: true,
              lineStyle: {
                color: '#1f3a5f'
              }
            },
            axisTick: {
              show: false, // 是否显示坐标轴轴线
            },
            axisLabel: { //坐标轴刻度标签的相关设置。
              show: false,
              // margin: 50,//距离
            },
          },
          series: [
            {
              type: 'line',
              data: [this.sameDayStatisticsTime.timeNumber1, this.sameDayStatisticsTime.timeNumber2, this.sameDayStatisticsTime.timeNumber3, this.sameDayStatisticsTime.timeNumber4, this.sameDayStatisticsTime.timeNumber5, this.sameDayStatisticsTime.timeNumber6, this.sameDayStatisticsTime.timeNumber7],
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                    offset: 0,
                    color: '#ffcc00'
                  }, {
                    offset: 1,
                    color: '#c13a41'
                  }]),
                  label : {
                    show: false,
                    color: '#ffffff'
                  }
                }
              },
              // markPoint: {
              //   data: [
              //     {type: 'max', name: '最大值'},
              //     {type: 'min', name: '最小值'}
              //   ]
              // }
            },
          ]
        });
        let myChart3 = echarts.init(document.getElementById('nlfb'));
        window.onresize = myChart3.resize;
        myChart3.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart3.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart3.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            bottom: '-1%',
            top:'15%',
            right:'1%',
            left:'0%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['6岁以下','6-25岁','26-35岁','36-45岁','46-59岁','60-64岁','65岁以上'],
              axisTick: {
                alignWithLabel: true,
              },
              axisLabel: {
                margin: 5,//距离
                interval: 0,
                color: '#ffffff',
                fontSize : 10
              },
              triggerEvent: true,
              axisLine: {
                lineStyle: {
                  color: '#3f51b5'
                }
              },
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLine: {
                show: false
              },
              splitLine: { // 网格线
                show: true,
                lineStyle: {
                  color: '#3f51b5'
                }
              },
              axisLabel: {
                textStyle: {
                  color: '#708acc'
                }
              }
            }
          ],
          series: [
            {
              data: [this.sameDayStatistics.oneYear, this.sameDayStatistics.twoYear, this.sameDayStatistics.threeYear, this.sameDayStatistics.fourYear, this.sameDayStatistics.fiveYear, this.sameDayStatistics.sixYear, this.sameDayStatistics.sevenYear],
              type: 'bar',
              barWidth: '50%',
              label:{
                show:true,
                position:'top',
                color:"#0efcff"
              },
              itemStyle: {
                //通常情况下：
                normal: {
                  //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                  color: function(params) {
                    var colorList = [
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#fb7f9d'
                      }, {
                        offset: 1,
                        color: '#fb406d'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#fe9b1a'
                      }, {
                        offset: 1,
                        color: '#fe421b'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#4ae4a0'
                      }, {
                        offset: 1,
                        color: '#05bc79'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#67e0e3'
                      }, {
                        offset: 1,
                        color: '#0282de'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#ac93fd'
                      }, {
                        offset: 1,
                        color: '#7853f1'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#fed701'
                      }, {
                        offset: 1,
                        color: '#fc9501'
                      }]),
                      new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#0282de'
                      }, {
                        offset: 1,
                        color: '#3f29d0'
                      }]),
                    ]; //每根柱子的颜色
                    return colorList[params.dataIndex];
                  }
                },
              }
            }
          ]
        });
        let myChart4 = echarts.init(document.getElementById('xbb'));
        window.onresize = myChart4.resize;
        myChart4.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart4.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: 0
        });
        myChart4.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            bottom: '17%',
            top:'12%',
            right: '25%',
            containLabel: false
          },
          xAxis: {
            type: 'category',
            data: ['男性', '女性'],
            axisLabel: {
              color: '#ffffff',
              fontSize : 10
            },
            axisLine: {
              lineStyle: {
                color: '#6fc9e7'
              }
            },
          },
          yAxis: {
            type: 'value',
            show:false,
          },
          series: [{
            data: [this.sameDayStatistics.yNv, this.sameDayStatistics.xNan],
            type: 'bar',
            barWidth: "15", //柱图宽度
            label:{
              show:true,
              position:'top',
            },
            itemStyle: {
              //通常情况下：
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function(params) {
                  var colorList = [
                    "#7a65f2",
                    "#f29e3c",
                  ]; //每根柱子的颜色
                  return colorList[params.dataIndex];
                },
                barBorderRadius: 15
              },
              emphasis: {
                barBorderRadius: 15
              },
            }
          }]
        });
      },
      openList() {
        this.showList = true;
      },
      closeList() {
        this.showList = false;
      },
    },


  }
</script>

<style scoped>
  .body {
    width: calc(100% - .6rem);
    /*height: 100%;*/
    background: url("../assets/img/gzh_bg.png") no-repeat;
    background-size: 100% 100%;
    padding: 0 .3rem .3rem .3rem;

  }

  .topTip{
    padding-top: .3rem;
    padding-bottom: .3rem;
    height: .36rem;
  }

  .top {
    position: fixed;
    top: 0px;
    flex-direction: row;
    justify-content: flex-end;
    padding-top: .3rem;
    padding-bottom: .3rem;
    width: calc(100% - .6rem);
    background-color: #01132f;
    z-index: 999;
  }

  .top > div {
    font-size: .36rem;
    font-family: "SourceHanSansCN";
    color: rgb(255, 255, 255);
    line-height: 1;
    display: inline-block;
  }

  .top > img {
    width: .4rem;
    height: .36rem;
    /*margin-left: 1.12rem;*/
    display: inline-block;
    float: right;
  }

  .qntj {
    margin-top: .3rem;
    width: 100%;
  }

  .rytj {
    width: 64%;
    display: inline-block;
    vertical-align: middle;
  }

  .ssd {
    display: inline-block;
    border: 1px solid rgb(53, 143, 255);
    width: 32%;
    height: 1.4rem;
    vertical-align: middle;
  }

  .yyssd {
    width: 100%;
    height: .5rem;
    background-color: rgba(0, 94, 210, 0.2);
    font-size: .25rem;
    font-family: "SourceHanSansCN";
    color: rgb(1, 237, 252);
    line-height: .5rem;
    text-align: center;
  }

  .yyssd_1 {
    font-size: .25rem;
    font-family: "SourceHanSansCN";
    color: rgb(248, 240, 35);
    line-height: 0.7rem;
    text-align: center;
    background: url("../assets/img/title_choose.png") no-repeat center;
    background-size: 70% 100%;
    height: 1.2rem;

  }

  .rytj > div > div {
    display: inline-block;
    font-size: .28rem;
    font-family: "SourceHanSansCN";
    color: rgb(1, 237, 252);
    line-height: 1.714;
  }

  .yellow {
    color: rgb(248, 240, 35);
    border-bottom: 1px solid rgb(248, 240, 35);
    width: 1.34rem
  }

  .part_1 {
    position: relative;
    border: 1px solid rgb(53, 143, 255);
    height: 2.5rem;
    width: calc(100% - 2px);
    margin-top: .46rem;

  }

  .part_img_1 {
    position: absolute;
    top: -0.03rem;
    left: -0.03rem;
    width: .29rem;
    height: .22rem;
  }

  .part_img_2 {
    position: absolute;
    top: -0.03rem;
    right: -0.03rem;
    width: .29rem;
    height: .22rem;
  }

  .part_img_3 {
    position: absolute;
    bottom: -0.03rem;
    left: -0.03rem;
    width: .29rem;
    height: .22rem;
  }

  .part_img_4 {
    position: absolute;
    bottom: -0.03rem;
    right: -0.03rem;
    width: .29rem;
    height: .22rem;
  }

  .part_title {
    font-size: .28rem;
    font-family: "SourceHanSansCN";
    color: rgb(254, 255, 255);
    line-height: .5rem;
    background-color: rgba(0, 94, 210, 0.2);
    width: calc(100% - .3rem);
    padding-left: .3rem;
  }

  .part_1_info {
    width: calc(48% - .3rem);
    display: inline-block;
    vertical-align: top;
    height: 1.75rem;
    margin-top: .15rem;
    margin-left: .3rem;
  }

  .part_2_info {
    width: calc(48% - .3rem);
    display: inline-block;
    vertical-align: top;
    height: 1.75rem;
    margin-top: .15rem;
    margin-right: .3rem;
  }

  .part_1_1 > div {
    display: inline-block;
    height: .5rem;
    vertical-align: top;
  }

  .ryrc {
    background-color: rgba(1, 196, 252, 0.2);
    height: .5rem;
    width: 1.6rem;
    font-size: .25rem;
    font-family: "SourceHanSansCN";
    color: rgb(9, 203, 239);
    text-align: center;
    line-height: .5rem;
  }

  .ryrc_num {
    background-color: rgba(29, 41, 99, 0.702);
    font-size: .24rem;
    width: 1.22rem;
    font-family: "SourceHanSansCN";
    color: #ffffff;
    text-align: center;
    height: .5rem;
    line-height: .5rem;
  }

  .part_2 {
    position: relative;
    border: 1px solid rgb(53, 143, 255);
    height: 3.2rem;
    width: calc(100% - 2px);
    margin-top: .46rem;
  }

  .data_table {
    margin-top: .2rem;
    position: relative;
    padding: 0 0.2rem;

  }

  .data_table img {
    position: absolute;
    top: 0;
    width: calc(100% - 0.4rem);
    height: .5rem;
  }

  .data_table > div {
    height: .5rem;
    line-height: .5rem;
  }

  .data_table > div > div {
    display: inline-block;
    width: 30%;
    text-align: center;
    font-size: .25rem;
    color: rgb(10, 218, 255);
    vertical-align: top;
  }

  .data_table_tr {
    height: calc(100% - 1.68rem);
    overflow: auto;
    padding: 0 0.2rem;
  }

  .data_table_tr ul {
    height: .5rem;
  }
  .data_table_tr ul:not(:last-child) {
    border-bottom: .01rem solid rgba(1, 237, 252, 0.239);
  }

  .data_table_tr ul li div {
    display: inline-block;
    width: 30%;
    font-size: .25rem;
    text-align: center;
    line-height: .5rem;
    color: rgb(255, 255, 255);
    white-space: nowrap;
  }

  .part_3 {
    margin-top: .46rem;
  }

  .part3_title {
    background: url("../assets/img/title_bg.png") no-repeat center;
    background-size: 100% 100%;
    height: .5rem;
    font-size: .28rem;
    font-family: "SourceHanSansCN";
    color: rgb(254, 255, 255);
    line-height: .5rem;
    padding-left: .28rem;
  }
  .minVideoViewBox{
    width:100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space:nowrap;
  }
  .miniStreamView{
    height: 0.75rem;
    display: inline-block;
    margin-left: .2rem;
  }

  .miniStreamView >div {
    margin-top: .26rem;
    font-size: .24rem;
    font-family: "SourceHanSansCN";
    color: rgb(255, 255, 255);
    line-height: 1;
  }

  /*.miniStreamView div:last-child {*/
  /*  height: calc(100% - .41rem);*/
  /*  width: 100%;*/
  /*  background-color: transparent;*/
  /*  margin-top: -1.57rem;*/
  /*  position: relative;*/
  /*}*/

  .minVideoViewBox :nth-child(2) {
    height: 1.8rem;
  }




  .part_4 {
    position: relative;
    border: 1px solid rgb(53, 143, 255);
    height: 12.88rem;
    width: calc(100% - 2px);
    margin-top: .16rem;
  }

  .excel_1 {
    width: calc(100% - .6rem);
    height: 2.46rem;
    padding: 0 .3rem;
    margin-top: .3rem;
  }

  .data_table3 {
    position: relative;

  }

  .data_table3 img {
    position: absolute;
    top: 0;
    width: 100%;
    height: .5rem;
  }

  .table3 {
    width: 100%;
    display: inline-block;
    font-size: .25rem;
    text-align: left;
    margin-left: .2rem;
    line-height: .5rem;
    color: rgb(10, 218, 255);
  }

  .excel_2 {
    width: calc(100% - .6rem);
    height: 3.34rem;
    padding: 0 .3rem;
    margin-top: .56rem;
  }

  .excel_3 {
    width: calc(100% - .6rem);
    height: 4.74rem;
    padding: 0 .3rem;
    margin-top: .56rem;
  }

  .part_5 {
    position: relative;
    border: 1px solid rgb(53, 143, 255);
    height: 7.63rem;
    width: calc(100% - 2px);
    margin-top: .46rem;
  }

  .excel_4 {
    width: calc(100% - .6rem);
    height: 2.89rem;
    padding: 0 .3rem;
    margin-top: .3rem;
  }

  .excel_5 {
    width: calc(100% - .6rem);
    height: 2.9rem;
    padding: 0 .3rem;
    margin-top: .56rem;
  }

  .excel_5_left {
    width: 46%;
    height: 3.2rem;
    display: inline-block;
    vertical-align: top;
  }

  .data_table4 {
    position: relative;
  }

  .data_table4 img {
    position: absolute;
    top: 0;
    width: 100%;
    height: .5rem;
  }

  .table4 {
    display: inline-block;
    font-size: .25rem;
    text-align: left;
    margin-left: .2rem;
    line-height: .5rem;
    color: rgb(10, 218, 255);
  }

  .part_6 {
    position: relative;
    border: 1px solid rgb(53, 143, 255);
    height: 4.16rem;
    width: calc(100% - 2px);
    margin-top: .46rem;
  }

  .data_table1 {
    margin-top: .2rem;
    position: relative;
    padding: 0 0.2rem;

  }

  .data_table1 img {
    position: absolute;
    top: 0;
    width: calc(100% - 0.4rem);
    height: .5rem;
  }

  .data_table1 > div {
    height: .5rem;
    line-height: .5rem;
  }

  .data_table1 > div > div {
    display: inline-block;
    width: 30%;
    text-align: center;
    font-size: .13rem;
    color: rgb(10, 218, 255);
  }

  .data_table_tr1 {
    height: calc(100% - 1.68rem);
    overflow: auto;
    padding: 0 0.2rem;
  }

  .data_table_tr1 ul {
    height: .8rem;
  }
  .data_table_tr1 ul:not(:last-child) {
    border-bottom: .01rem solid rgba(1, 237, 252, 0.239);
  }

  .data_table_tr1 ul li {
    border: none;
  }

  .data_table_tr1 ul li div {
    display: inline-block;
    width: 30%;
    font-size: .11455rem;
    text-align: center;
    line-height: .8rem;
    color: rgb(255, 255, 255);
    white-space: nowrap;
  }

  .showQRCode {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999999;
    background-color: rgba(102, 102, 102, 0.702);
  }

  .showQRCode .bars {
    width: 7.5rem;
    height: 1.46rem;
    vertical-align: top;
  }

  .showQRCode .bars :nth-child(1) {
    width: 5.56rem;
    height: 1.46rem;
    padding-left: 0.48rem;
    background-color: #f5f5f4;
    font-size: 0.36rem;
    font-family: "SourceHanSansCN";
    color: rgb(19, 76, 154);
    line-height: 1.46rem;
  }

  .showQRCode .bars :nth-child(2) {
    width: 1.46rem;
    height: 1.46rem;
    background-color: rgb(5, 38, 83);
    font-size: 0.6rem;
    font-family: "PingFang";
    color: #FFFFFF;
    line-height: 1.46rem;
    text-align: center;
    position: absolute;
    top: 0;
    left: 6.05rem;
  }

  ul {
    list-style-type: none;
  }

  .parentWrap {
    width: 6.04rem;
    height: 100%;
    background-color: #ffffff;
  }

  .menuGroup {
    width: 5.56rem;
    padding-left: 0.48rem;
    min-height: 1.06rem;
  }

  .groupTitle {
    display: block;
    font-size: 0.36rem;
    font-family: "PingFang";
    line-height: 1.06rem;
    color: rgb(51, 51, 51);
    cursor: pointer;
  }

  .groupTitle > div {
    width: 4rem;
    display: inline-block;
  }

  .menuGroup > div {
    width: 5.09rem;
    height: 1.06rem;
    font-size: 0.3rem;
    font-family: "PingFang";
    color: rgb(102, 102, 102);
    line-height: 1.06rem;
    border-bottom: 0.02rem solid #eeeeee;
    display: none;
  }

  .menuGroup :last-child {
    border-bottom: none;

  }

  /*.xia {
    width: 0.25rem;
    height: 0.14rem;
    margin-left: .3rem;
    display: inline-block;
  }*/
  .excel_5_info {
    margin-left: .2rem ;
  }
  .excel_5_info > div {
    display: inline-block;
    font-size: .25rem;
    font-family: "SourceHanSansCN";
    color: rgb(248, 240, 35);
    line-height: 1.8;
    width: 0.6rem;
    white-space: nowrap;
    overflow: hidden;
  }
  .excel_5_info > div:nth-child(2) {
    width: 1rem;
  }
  .data_table2 {
    margin-top: .2rem;
    position: relative;
    padding: 0 0.2rem;

  }

  .data_table2 img {
    position: absolute;
    top: 0;
    width: calc(100% - 0.4rem);
    height: .5rem;
  }

  .data_table2 > div {
    height: .5rem;
    line-height: .5rem;
  }

  .data_table2 > div > div {
    display: inline-block;
    width: 23%;
    text-align: center;
    font-size: .25rem;
    color: rgb(10, 218, 255);
  }

  .data_table_tr2 {
    height: calc(100% - 1.68rem);
    overflow: auto;
    padding: 0 0.2rem;
  }

  .data_table_tr2 ul {
    height: .8rem;
  }
  .data_table_tr2 ul:not(:last-child) {
    border-bottom: .01rem solid rgba(1, 237, 252, 0.239);
  }

  .data_table_tr2 ul li {
    border: none;
  }

  .data_table_tr2 ul li div {
    display: inline-block;
    width: 23%;
    font-size: .25rem;
    text-align: center;
    line-height: .8rem;
    color: rgb(255, 255, 255);
    white-space: nowrap;
  }
  .gsdrs {
    width: 100%;
    height: 1.96rem;
  }
  .jqyyrs {
    width: 100%;
    height: 2.85rem;
  }
  .gysplx {
    width: 100%;
    height: 4.24rem;
  }
  .nlfb {
    width: 100%;
    height: 2.39rem;
  }
  .xbb {
    width: 100%;
    height: 2.8rem;
  }
  .nvr {
    width: 2.6rem;
    overflow: hidden;
  }
  iframe {
    margin-top: -.71rem;
    margin-left: -.34rem;
    height: 123%;
    width: 3.3rem;
  }

  .playNvr{
    background-color: #011029;
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    filter: alpha(opacity=60);
    z-index: 1111111111;
  }

  .playNvr .nvrTitle{
    background-color: rgba(0, 94, 210, 0.2);
    height: .48rem;
    width: 100%;
    /*margin-top: 4rem;*/
  }
  .playNvr .nvrTitle .close {
    font-family: "SourceHanSansCN";
    font-size: .4rem;
    width: .48rem;
    height: 100%;
    line-height: .48rem;
    color: #7e8c8d;
    font-weight: bold;
    float: right;
    margin-right: .12rem;
  }

  .playNvr .nvrUrl{
    width: 100%;
    overflow: hidden;
    height: 4rem;
  }

  .playNvr .nvrUrl iframe{
    width: 135%;
    height: 117.8%;
    margin-left: -1.1rem;
    margin-top: -.73rem;
  }

  .showNvr{
    width: 100%;
    background-color: transparent;
    position: relative;
    height: 1.8rem;
    top: -2.06rem;
  }

  .qx_info{
    font-size: .28rem;
    font-family: "SourceHanSansCN";
    color: rgb(1, 237, 252);
    margin-top: .2rem;
    line-height: 1.714;
  }

  .qx_info div{
    display: inline-block;
    margin-right: .42rem;
  }

  .qx_info div:last-child{
    margin-right: 0;
  }

  .qx_info img{
    width: .28rem;
    height: .28rem;
    margin-right: .1rem;
  }

  .tq_img4{
    width: .4rem;
    height: .4rem;
  }

  .qx_info .tq_img3{
    width: .22rem;
    height: .28rem;
  }

  .qx_info span{
    color: rgb(248, 240, 35) !important;
    margin-left: .4rem;
  }

  .tqinfo1{
    height: .34rem;
    overflow: hidden;
    top: .1rem;
    position: relative;
    width: 2.2rem;
  }

  .tqinfo1 div{
    position: relative;
    width: 2.2rem;
    height: .6rem;
    z-index: 99;
    top: -.2rem;
  }

  .tqinfo1 iframe{
    position: absolute;
    top: -0.44rem;
    margin-top: 0;
    margin-left: 0;
    height: 1rem;
    width: 2.2rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/app_dp.vue